import React, { useEffect, createContext, useReducer } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import "../../../assets/css/profile.page.css";
import "../../../assets/css/utility/map.css";
import "../../../assets/css/utility/input-field.css";
import "../../../assets/css/utility/modal.css";
import "../../../assets/css/create-load-post.css";
import "../../../assets/css/load-post-details-page.css";

import LoadPostUserInfo from "./components/LoadPostUserInfo";
import RouteMap from "./components/RouteMap";
import CarrierOffers from "./components/CarrierOffers";
import UserReviews from "../../../components/UserReviews";
import SendOffer from "./components/SendOffer";
import CarrierCounterOfferArea from "./components/CarrierCounterOfferArea";
import CounterModal from "./components/Modals/CounterOfferModal";
import OfferDetailsModal from "./components/Modals/OfferDetailsModal";
import useHttp from "../../../hooks/useHttp";
import {
  SINGLE_LOAD_POST_UPDATE_URL,
  CARRIER_INDIVIDUAL_LOAD_POST_ACTIVITY_URL,
  LOAD_POST_WITHDRAW_URL,
} from "../../../utils/api-ends";
import LoaderImg from "../../../assets/media/loader.gif";
import CarrierSpeficificLoadPostOfferInfo from "./components/CarrierSpeficificLoadPostOfferInfo";

export const ManageLoadPostDetailPageContext = createContext();

const initialLoadPostDetailState = {
  headerTopSuccessMsg: "",
  loadPostDetail: {},
  offerList: {},
  counterModal: {
    status: false,
    modalData: {},
    openFrom: "",
  },
  offerDetailModal: {
    status: false,
    modalData: {},
  },
  carrierActivity: {},
  offerCurrentAmount: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_LOAD_POST_DETAILS":
      return {
        ...state,
        loadPostDetail: action.payload,
      };
    case "WITHDRAW_LOAD_POST":
      return {
        ...state,
        loadPostDetail: {
          ...state.loadPostDetail,
          status: "withdrawn",
          can_withdraw: false,
        },
      };
    case "FETCH_OFFER_LIST":
      return {
        ...state,
        offerList: action.payload,
      };
    case "LOAD_MORE_OFFERS":
      return {
        ...state,
        offerList: {
          pagination: action.payload.pagination,
          results: {
            ...state.offerList?.results,
            ...action.payload.results,
          },
        },
      };
    case "SHIPPER_REJECT_COUNTER_OFFER":
      return {
        ...state,
        offerList: {
          ...state.offerList,
          results: state.offerList.results.map((offer) => {
            if (offer.id === action.payload) {
              offer.counter_status = "rejected";
            }
            return offer;
          }),
        },
      };
    case "SHIPPER_STOP_COUNTER_OFFER":
      return {
        ...state,
        offerList: {
          ...state.offerList,
          results: state.offerList.results.map((offer) => {
            if (offer.id === action.payload) {
              offer.counter_status = "stopped";
            }
            return offer;
          }),
        },
      };
    case "SHIPPER_COUNTER_OFFER":
      return {
        ...state,
        offerList: {
          ...state.offerList,
          results: state.offerList?.results.map((offer) => {
            if (offer.id === action.payload.id) {
              if (action.payload.isFixedPrice === true) {
                offer.is_counter_amount_fixed = true;
              }
              offer.can_counter = false;
              offer.counter_amount = action.payload.amount;
              offer.counter_offer_by = "me";
              offer.counter_status = "in_progress";
              offer.counter_status_display = "In Progress";
            }
            return offer;
          }),
        },
      };
    case "SHIPPER_ACCEPT_COUNTER_OFFER":
      return {
        ...state,
        offerList: {
          ...state.offerList,
          results: state.offerList.results.map((offer) => {
            if (offer.id === action.payload) {
              offer.counter_status = "accepted";
              offer.status = "accepted";
              offer.can_counter = false;
            }
            return offer;
          }),
        },
      };

    case "OPEN_COUNTER_MODAL":
      return {
        ...state,
        counterModal: {
          status: true,
          modalData: action.payload.data,
          openFrom: action.payload.openFrom,
        },
      };
    case "CLOSE_COUNTER_MODAL":
      return {
        ...state,
        counterModal: {
          status: false,
          modalData: {},
          openFrom: "",
        },
      };

    case "OPEN_OFFER_DETAILS_MODAL":
      return {
        ...state,
        offerDetailModal: {
          status: true,
          modalData: action.payload.data,
        },
      };
    case "CLOSE_OFFER_DETAILS_MODAL":
      return {
        ...state,
        offerDetailModal: {
          status: false,
          modalData: {},
        },
      };

    case "HEADER_SUCCESS_MSG":
      return {
        ...state,
        headerTopSuccessMsg: action.payload,
      };

    case "FETCH_CARRIER_ACTIVITY":
      return {
        ...state,
        carrierActivity: action.payload,
      };
    case "CARRIER_ACCEPT_COUNTER_OFFER":
      return {
        ...state,
        carrierActivity: {
          ...state.carrierActivity,
          counter_status: "accepted",
          counter_status_display: "Accepted",
          can_counter: false,
        },
      };
    case "CARRIER_REJECT_COUNTER_OFFER":
      return {
        ...state,
        carrierActivity: {
          ...state.carrierActivity,
          counter_status: "rejected",
          counter_status_display: "Rejected",
        },
      };
    case "CARRIER_STOP_COUNTER_OFFER":
      return {
        ...state,
        carrierActivity: {
          ...state.carrierActivity,
          counter_status: "stopped",
          counter_status_display: "Stopped",
          can_counter: false,
        },
      };
    case "CARRIER_SEND_OFFER_SUCCESSFULLY":
      return {
        ...state,
        carrierActivity: {
          ...state.carrierActivity,
          ...action.payload,
          is_already_send_offer: true, 
        },
        headerTopSuccessMsg:
          "Your offer has been submitted. Wait for shipper response. You can also withdraw your offer.",
      };
    case "CARRIER_COUNTER_OFFER":
      return {
        ...state,
        carrierActivity: {
          ...state.carrierActivity,
          can_counter: false,
          amount: action.payload.amount,
          counter_amount: action.payload.amount,
          counter_offer_by: "me",
          counter_status: "in_progress",
          counter_status_display: "In Progress",
          is_counter_amount_fixed: action.payload.isFixedPrice,
        },
      };
    case "CARRIER_WITHDRAW_OFFER":
      return {
        ...state,
        carrierActivity: {
          ...state.carrierActivity,
          can_withdraw: false,
          status_value: "Withdrawn",
          can_reactive: true,
        },
      };
    case "CARRIER_REACTIVE_OFFER":
      return {
        ...state,
        carrierActivity: {
          ...state.carrierActivity,
          can_withdraw: true,
          status_value: "Pending",
          can_reactive: false,
        },
      };
    case "SET_IS_OFFER_CURRENT_AMOUNT":
      return {
        ...state,
        offerCurrentAmount: action.payload,
      };
    default:
      return state;
  }
};

const LoadPostDetailPage = () => {
  const [loadPostDetailState, loadPostDetailContextDispatch] = useReducer(
    reducer,
    initialLoadPostDetailState
  );

  const navigate = useNavigate();
  const { loadPostId } = useParams();
  const userDetails = useSelector((state) => state.basicInfo.userDetails);

  const {
    isLoading: isLoadingLoadPostDetails,
    sendRequests: fetchLoadPostDetailData,
  } = useHttp();
  const {
    isLoading: isLoadingCarrierActivity,
    sendRequests: fetchCarrierIndividualLoadsInfo,
  } = useHttp();
  const { isLoading: withdrawLoading, sendRequests: withdrawRequest } =
    useHttp();

  // Fetch Load Feed Detail
  useEffect(() => {
    const response = (data) => {
      loadPostDetailContextDispatch({
        type: "FETCH_LOAD_POST_DETAILS",
        payload: data,
      });
    };
    fetchLoadPostDetailData(
      {
        url: SINGLE_LOAD_POST_UPDATE_URL(loadPostId),
      },
      response
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostId]);

  // Fetch carrier individual loads info
  useEffect(() => {
    if (userDetails?.user_type === "carrier") {
      const response = (data) => {
        loadPostDetailContextDispatch({
          type: "FETCH_CARRIER_ACTIVITY",
          payload: data?.data,
        });
      };
      fetchCarrierIndividualLoadsInfo(
        {
          url: CARRIER_INDIVIDUAL_LOAD_POST_ACTIVITY_URL(
            userDetails.id,
            loadPostId
          ),
        },
        response
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostId, userDetails?.id]);

  const handleWithdraw = () => {
    // Clear the success message
    loadPostDetailContextDispatch({
      type: "HEADER_SUCCESS_MSG",
      payload: "",
    });

    const response = (data) => {
      // Update state
      loadPostDetailContextDispatch({
        type: "WITHDRAW_LOAD_POST",
      });

      // Show the success message
      loadPostDetailContextDispatch({
        type: "HEADER_SUCCESS_MSG",
        payload: data?.message,
      });

      window.scrollTo(0, 0);
    };
    withdrawRequest(
      {
        url: LOAD_POST_WITHDRAW_URL(loadPostId),
        method: "patch",
      },
      response
    );
  };

  // Redirect to home if the Load Feed is ordered or completed except owner
  useEffect(() => {
    if (
      ["ordered", "withdrawn"].includes(
        loadPostDetailState.loadPostDetail?.status
      ) &&
      loadPostDetailState.loadPostDetail?.is_owner !== true
    ) {
      window.location.href = "/";
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostDetailState.loadPostDetail]);

  return (
    <ManageLoadPostDetailPageContext.Provider
      value={[loadPostDetailState, loadPostDetailContextDispatch]}
    >
      {loadPostDetailState.headerTopSuccessMsg?.length > 0 && (
        <section className="loads-details-alerts">
          <div className="container theme-section">
            <p className="large-text text-center">
              {loadPostDetailState.headerTopSuccessMsg}
            </p>
          </div>
        </section>
      )}

      {userDetails?.user_type === "carrier" &&
        loadPostDetailState.carrierActivity?.has_counter_offer === true && (
          <CarrierCounterOfferArea />
        )}

      <LoadPostUserInfo isLoading={isLoadingLoadPostDetails} />

      {userDetails?.user_type === "carrier" &&
        loadPostDetailState.carrierActivity?.is_already_send_offer ===
          false && <SendOffer loadPostId={loadPostId} />}

      {userDetails?.user_type === "shipper" &&
        loadPostDetailState.loadPostDetail?.is_owner === true && (
          <CarrierOffers />
        )}

      {userDetails?.user_type === "carrier" &&
        loadPostDetailState.carrierActivity?.is_already_send_offer === true && (
          <CarrierSpeficificLoadPostOfferInfo
            isLoadingCarrierActivity={isLoadingCarrierActivity}
            offer={loadPostDetailState.carrierActivity}
          />
        )}

      <RouteMap />

      {userDetails?.user_type === "carrier" && (
        <UserReviews
          userId={loadPostDetailState.loadPostDetail?.shipper_obj?.id}
        />
      )}

      {userDetails?.user_type === "shipper" &&
        loadPostDetailState.loadPostDetail?.is_owner === true && (
          <section className="withdrow-update-btn">
            <div className="container">
              <div className="multiple-btn flex-direction-initial">
                {loadPostDetailState.loadPostDetail?.can_update === true && (
                  <button
                    className="m-0"
                    onClick={() => {
                      navigate(`/load-post/update/${loadPostId}`);
                    }}
                  >
                    Update
                  </button>
                )}
                {loadPostDetailState.loadPostDetail?.can_withdraw === true && (
                  <button className="m-0" onClick={handleWithdraw}>
                    Withdraw
                    {withdrawLoading && (
                      <img src={LoaderImg} style={{ width: "24px" }} alt="" />
                    )}
                  </button>
                )}
              </div>
            </div>
          </section>
        )}

      <CounterModal userDetails={userDetails} />
      <OfferDetailsModal />
    </ManageLoadPostDetailPageContext.Provider>
  );
};

export default LoadPostDetailPage;
